export default "__VITE_ASSET__DHtn2Peg__"